import React, { useCallback, useEffect, useState, useRef } from "react";
import {
  Form,
  Row,
  Col,
  InputGroup,
  Card,
  Button,
  Table,
} from "react-bootstrap";
import {
  IconCopyMinus,
  IconGridDots,
  IconInvoice,
  IconSearch,
  IconCoin,
  IconPercentage,
  IconCurrencyDollar,
  IconArrowNarrowRight,
  IconPlus,
  IconTrash,
  IconLock,
  IconLockOpen2,
  IconArrowsUpDown,
} from "@tabler/icons-react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { useSelector } from "react-redux";
import { useFormContext, useFieldArray } from "react-hook-form";
import {
  API_ENDPOINTS,
  handleKeyDown,
  roundToMoney,
  trimText,
  truncateFormat,
} from "../../constant/_constant";
import SkuSearchPopUp from "./SkuSearchPopUp";

import useDebounce from "../../hooks/useDebounce";
import usePostRequest from "../../hooks/usePostRequest";
import { toast } from "react-toastify";
import AddQuickbookVendor from "./AddQuickbookVendor";

function OtherDetailsForm({ isEditing, clinBaseCount = 0 }) {
  const {
    getValues,
    register,
    watch,
    control,
    formState: { errors },
    setValue,
  } = useFormContext();
  const contractName = useSelector((state) => state.contract.contractName);

  const textareaRef = useRef(null);

  const [dataSuggetion, setDataSuggetion] = useState([]);

  const [height, setHeight] = useState();
  const [shippingHide, setShippingHide] = useState(false);
  const [showSkuId, setShowSkuId] = useState(false);
  const [totalCostBeforeMargin, setTotalCostBeforeMargin] = useState("0.00");
  const [totalCostAfterMargin, setTotalCostAfterMargin] = useState("0.00");
  const [showModal, setShowModal] = useState(false);
  const [quickbookVendor, setQuickbookVendor] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedProductPopup, setSelectedProductPopup] = useState(null);
  const [quickbookVendorPopup, setQuickbookVendorPopup] = useState(null);

  const [searchProps, setSearchProps] = useState({
    searchSku: "",
    searchDescription: "",
    searchVendor: "",
    indexIs: "",
    ContractName: "",
  });

  const handleOpenModal = (index, type) => {
    if (index === null && type === "skuAll") {
      const currentCards = getValues("cards");
      const blankIndex = currentCards.findIndex(
        (card) => !card.skuId && !card.cost && !card.skuDescription,
      );

      if (blankIndex !== -1) {
        setSearchProps({
          searchSku: "",
          searchDescription: "",
          searchVendor: "",
          indexIs: blankIndex,
        });
      } else {
        setSearchProps({
          searchSku: "",
          searchDescription: "",
          searchVendor: "",
          indexIs: undefined,
        });
      }
    } else if (index === null && type === "contract") {
      const currentCards = getValues("cards");
      const blankIndex = currentCards.findIndex(
        (card) => !card.skuId && !card.cost && !card.skuDescription,
      );

      // setSearchProps({
      //   searchSku: "",
      //   searchDescription: "",
      //   searchVendor: "",
      //   ContractName: contractName,
      // });

      if (blankIndex !== -1) {
        setSearchProps({
          searchSku: "",
          searchDescription: "",
          searchVendor: "",
          ContractName: contractName,
          indexIs: blankIndex,
        });
      } else {
        setSearchProps({
          searchSku: "",
          searchDescription: "",
          searchVendor: "",
          ContractName: contractName,
          indexIs: undefined,
        });
      }
    } else {
      const { vendor, sku, description } = cardSearch[index];
      setSearchProps({
        searchSku: sku,
        searchDescription: description,
        searchVendor: vendor,
        indexIs: index,
      });
    }
    setShowModal(true);
  };

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const ordertype = watch("ordertype");

  const {
    fields: cardFields,
    append: appendCard,
    remove: removeCard,
  } = useFieldArray({
    control,
    name: "cards",
  });

  const {
    fields: otherCostFields,
    append: appendOtherCost,
    remove: removeOtherCost,
  } = useFieldArray({
    control,
    name: "otherCost",
  });

  const handleAddOtherCost = () => {
    appendOtherCost({
      Name: "",
      Amount: "",
    });
  };

  const generateUniqueId10 = () => {
    const array = new Uint8Array(8);
    crypto.getRandomValues(array);

    const id = btoa(String.fromCharCode(...array))
      .replace(/[^a-zA-Z0-9]/g, "")
      .slice(0, 10);

    console.log("Generated ID:", id);
    return id;
  };

  const pad4 = (n) => String(n).padStart(4, "0");

  const reindexClins = () => {
    const current = getValues("cards") || [];
    current.forEach((_, i) => setValue(`cards[${i}].clin`, pad4(i + 1)));
  };

  const getNextClin = () => {
    const current = getValues("cards") || [];
    const nums = current
      .map((c) => parseInt(c.clin, 10))
      .filter((n) => !isNaN(n));
    const maxExisting = nums.length ? Math.max(...nums) : 0;
    const base = isEditing ? clinBaseCount : 0;
    return pad4(Math.max(maxExisting, base) + 1);
  };

  const handleAddCard = () => {
    const rowId = generateUniqueId10();
    appendCard({
      vendorPartner: "",
      skuId: "",
      skuDescription: "",
      purchase_description: "",
      internalSku: "",
      variantId: "",
      productName: "",
      rowId: rowId,
      clin: getNextClin(),
      qty: 1,
      um: "EA",
      cost: "",
      margin: 0,
      customerCost: "",
      totalSkuCost: "",
    });
    // calculateCosts();
  };

  const handleQuickbookPopup = (quickbookVendor, product) => {
    console.log("popup function handle triggered");
    if (product?.customer_price === "0.00") {
      appendCard({
        vendorPartner: quickbookVendor,
        skuId: product?.sku_display_name,
        skuIdUnique: product?.sku_id,
        // skuId: product?.sku_id,
        skuDescription: product?.description_sales,
        productName: product?.name,
        purchase_description: product?.description,
        internalSku: product?.internal_id || product?.vendor_sku || "",
        variantId: product?.variant_id || product?.Product?.variant_id || "",
        qty: 1,
        um: "EA",
        cost: product?.aspetto_price,
        margin: 8,
        // customerCost: (product?.aspetto_price / (1 - 8 / 100)).toFixed(2),
        // customerCost: truncateFormat(product?.aspetto_price / (1 - 8 / 100), 2),
        customerCost: roundToMoney(product?.aspetto_price / (1 - 8 / 100)),
        totalSkuCost: product?.aspetto_price,
      });
    } else {
      const margin =
        ((product?.customer_price - product?.aspetto_price) /
          product?.customer_price) *
        100;
      appendCard({
        vendorPartner: quickbookVendor,
        skuId: product?.sku_display_name,
        skuIdUnique: product?.sku_id,
        // skuId: product?.sku_id,
        skuDescription: product?.description_sales,
        productName: product?.name,
        purchase_description: product?.description,
        internalSku: product?.internal_id || product?.vendor_sku || "",
        variantId: product?.variant_id || product?.Product?.variant_id || "",
        qty: 1,
        um: "EA",
        cost: product?.aspetto_price,
        // margin: parseFloat(margin.toFixed(2)),
        margin: truncateFormat(margin, 2),
        customerCost: product?.customer_price,
        totalSkuCost: product?.aspetto_price,
      });
    }

    calculateCosts();
    setQuickbookVendorPopup(null);
  };

  useEffect(() => {
    if (quickbookVendorPopup && selectedProductPopup) {
      // console.log("POPUP function trigger for checking");
      handleQuickbookPopup(quickbookVendorPopup, selectedProductPopup);
      setSelectedProduct(null);
    }
  }, [quickbookVendorPopup]);

  const handleAddSku = (product) => {
    console.log("product", product);

    const rowId = generateUniqueId10();

    if (product?.customer_price === "0.00") {
      appendCard({
        vendorPartner: product?.Vendor?.display_name,
        // skuId: product?.sku_id,
        skuId: product?.sku_display_name,
        skuIdUnique: product?.sku_id,
        skuDescription: product?.description_sales,
        purchase_description: product?.description,
        productName: product?.name,
        internalSku: product?.internal_id || product?.vendor_sku || "",
        variantId: product?.variant_id || "",
        qty: 1,
        um: "EA",
        rowId: rowId,
        clin: getNextClin(),
        cost: product?.aspetto_price,
        margin: 8,
        // customerCost: (product?.aspetto_price / (1 - 8 / 100)).toFixed(2),
        // customerCost: truncateFormat(product?.aspetto_price / (1 - 8 / 100), 2),
        customerCost: roundToMoney(product?.aspetto_price / (1 - 8 / 100)),
        // totalSkuCost: (product?.aspetto_price / (1 - 8 / 100)).toFixed(2),
        // totalSkuCost: truncateFormat(product?.aspetto_price / (1 - 8 / 100), 2),
        totalSkuCost: roundToMoney(product?.aspetto_price / (1 - 8 / 100)),
      });
    } else {
      const margin =
        ((product?.customer_price - product?.aspetto_price) /
          product?.customer_price) *
        100;
      appendCard({
        vendorPartner: product?.Vendor?.display_name,
        // skuId: product?.sku_id,
        skuId: product?.sku_display_name,
        skuIdUnique: product?.sku_id,
        skuDescription: product?.description_sales,
        purchase_description: product?.description,
        productName: product?.name,
        internalSku: product?.internal_id || product?.vendor_sku || "",
        variantId: product?.variant_id || "",
        qty: 1,
        um: "EA",
        rowId: rowId,
        clin: getNextClin(),
        cost: product?.aspetto_price,
        // margin: parseFloat(margin.toFixed(2)),
        margin: truncateFormat(margin, 2),
        customerCost: product?.customer_price,
        totalSkuCost: product?.customer_price,
      });
    }
    calculateCosts();
    toast.success(`Product ${product.sku_display_name} is added successfully`);
  };

  const handleLockUnLock = (e, index, type) => {
    e.stopPropagation();
  };

  useEffect(() => {
    const existingCards = getValues("cards");
    const rowId = generateUniqueId10();
    if (!existingCards || existingCards.length === 0) {
      appendCard({
        vendorPartner: "",
        skuId: "",
        skuDescription: "",
        purchase_description: "",
        productName: "",
        internalSku: "",
        variantId: "",
        rowId: rowId,
        clin: "0001",
        qty: 1,
        um: "EA",
        cost: "",
        margin: 0,
        customerCost: "",
        totalSkuCost: "",
      });
    }
  }, [appendCard, getValues]);

  const handleRemoveCard = (index) => {
    if (cardFields.length > 1) {
      removeCard(index);
      setTimeout(() => {
        if (!isEditing) reindexClins();
        const updatedCards = getValues("cards");
        calculateCosts(updatedCards);
      }, 0);
    }
  };

  const handleRemoveOthercost = (index) => {
    const currentOthercost = getValues("otherCost");
    if (otherCostFields.length > 0) {
      removeOtherCost(index);
      setTimeout(() => {
        const updatedOthercost = getValues("otherCost");
        calculateCosts(updatedOthercost);
      }, 0);
    }
  };

  const handleDragEnd = (result) => {
    const { destination, source } = result;
    if (!destination || destination.index === source.index) return;
    const currentValues = getValues("cards");
    const reorderedCards = [...currentValues];
    const [removed] = reorderedCards.splice(source.index, 1);
    reorderedCards.splice(destination.index, 0, removed);
    setValue("cards", reorderedCards);
    if (!isEditing)
      reorderedCards.forEach((_, i) =>
        setValue(`cards[${i}].clin`, pad4(i + 1)),
      );
  };

  // const calculateCosts = (name) => {
  //   let currentfield = "";
  //   let currentindex = null;
  //   if (typeof name === "string") {
  //     const pathParts = name.match(/cards\[(\d+)\]\.(\w+)/);
  //     currentindex = pathParts ? parseInt(pathParts[1]) : null;
  //     currentfield = pathParts ? pathParts[2] : null;
  //   }

  //   let totalBeforeMargin = 0;
  //   let totalAfterMargin = 0;

  //   const cards = getValues("cards") || [];
  //   const otherCost = getValues("otherCost") || [];

  //   const shippingCost = parseFloat(getValues("shippingCost")) || 0;
  //   const tax = parseFloat(getValues("tax")) || 0;

  //   cards?.forEach((card, index) => {

  //     if (currentfield !== "" && currentindex !== null && currentindex !== index) {
  //       // This card didn't change - just add its totals
  //       totalBeforeMargin += parseFloat(card.cost || 0) * parseFloat(card.qty || 0);
  //       totalAfterMargin += parseFloat(card.customerCost || 0) * parseFloat(card.qty || 0);
  //       return; // Skip recalculation for this card
  //     }

  //     if (currentfield != "" && currentindex === index) {
  //       const customerCostLock = card.customerCostLock;
  //       const costLock = card.CostLock;
  //       const marginLock = card.marginLock;
  //       const qty = parseFloat(card.qty) || 0;
  //       let cost = parseFloat(card.cost) || 0;
  //       let margin = parseFloat(card.margin) || 0;
  //       let customerCost = parseFloat(card.customerCost) || 0;
  //       let totalSkuCost = 0;
  //       const lockFields = ["customerCostLock", "CostLock", "marginLock"];

  //       if (lockFields.includes(currentfield)) {
  //         return;
  //       }

  //       if (
  //         customerCostLock == false &&
  //         costLock == false &&
  //         marginLock == false
  //       ) {
  //         if (currentfield == "customerCost") {
  //           // margin = parseFloat((customerCost / cost - 1) * 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           if (cost == 0) {
  //             margin = 0;
  //             setValue(
  //               `cards[${cards.indexOf(card)}].cost`,
  //               truncateFormat(totalSkuCost, 2)
  //             );
  //           } else {
  //             margin = parseFloat(((customerCost - cost) / customerCost) * 100);
  //           }
  //           setValue(
  //             `cards[${cards.indexOf(card)}].margin`,
  //             truncateFormat(margin, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         } else {
  //           // const customerCost = cost * (1 + margin / 100);
  //           const customerCost = cost / (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].customerCost`,
  //             truncateFormat(customerCost, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         }
  //       } else if (customerCostLock == true) {
  //         if (currentfield == "cost") {
  //           // margin = parseFloat((customerCost / cost - 1) * 100);
  //           margin = parseFloat(((customerCost - cost) / customerCost) * 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].margin`,
  //             truncateFormat(margin, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         } else if (currentfield == "margin") {
  //           // margin = parseFloat((customerCost / cost - 1) * 100);
  //           const costCust = customerCost * (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].cost`,
  //             truncateFormat(costCust, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         } else {
  //           // margin
  //           // cost = customerCost / (1 + margin / 100);
  //           const customerCost = cost / (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].cost`,
  //             truncateFormat(cost, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         }
  //       } else if (marginLock == true) {
  //         if (currentfield == "cost") {
  //           // const customerCost = cost * (1 + margin / 100);
  //           const customerCost = cost / (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].customerCost`,
  //             truncateFormat(customerCost, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         } else if (currentfield == "customerCost") {
  //           const costCust = customerCost * (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].cost`,
  //             truncateFormat(costCust, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         } else {
  //           // customer cost
  //           // cost = customerCost / (1 + margin / 100);
  //           const customerCost = cost / (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].cost`,
  //             truncateFormat(cost, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         }
  //       } else if (costLock == true) {
  //         if (currentfield == "margin") {
  //           // const customerCost = cost * (1 + margin / 100);
  //           const customerCost = cost / (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].customerCost`,
  //             truncateFormat(customerCost, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         } else {
  //           // customer cost change , need to calculate margin
  //           // margin = parseFloat((customerCost / cost - 1) * 100);
  //           margin = parseFloat(((customerCost - cost) / customerCost) * 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].margin`,
  //             truncateFormat(margin, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         }
  //       }
  //       totalBeforeMargin += cost * qty;
  //       totalAfterMargin += parseFloat(totalSkuCost);
  //     } else {
  //       totalBeforeMargin += parseFloat(card.cost * card.qty);
  //       totalAfterMargin += parseFloat(card.customerCost * card.qty);
  //     }
  //   });

  //   // Calculate costs for each other cost
  //   otherCost?.forEach((costItem) => {
  //     const amount = parseFloat(costItem.Amount) || 0;
  //     if (amount > 0) {
  //       totalBeforeMargin += parseFloat(amount);
  //       totalAfterMargin += parseFloat(amount);
  //     }
  //   });

  //   if (shippingCost > 0) {
  //     totalBeforeMargin += parseFloat(shippingCost);
  //     totalAfterMargin += parseFloat(shippingCost);
  //   }

  //   // Add tax if enabled
  //   if (tax > 0) {
  //     // console.log('tax', tax);
  //     totalBeforeMargin += parseFloat(tax);
  //     totalAfterMargin += parseFloat(tax);
  //   }

  //   // Set the final values
  //   setTotalCostBeforeMargin(truncateFormat(totalBeforeMargin, 2));
  //   setTotalCostAfterMargin(truncateFormat(totalAfterMargin, 2));

  //   // Update form state
  //   setValue("totalCostBeforeMargin", truncateFormat(totalBeforeMargin, 2));
  //   setValue("totalCostAfterMargin", truncateFormat(totalAfterMargin, 2));
  // };

  const calculateCosts = (name) => {
    let currentfield = "";
    let currentindex = null;
    if (typeof name === "string") {
      const pathParts = name.match(/cards\[(\d+)\]\.(\w+)/);
      currentindex = pathParts ? parseInt(pathParts[1]) : null;
      currentfield = pathParts ? pathParts[2] : null;
    }

    let totalBeforeMargin = 0;
    let totalAfterMargin = 0;

    const cards = getValues("cards") || [];
    const otherCost = getValues("otherCost") || [];

    const shippingCost = parseFloat(getValues("shippingCost")) || 0;
    const tax = parseFloat(getValues("tax")) || 0;

    cards?.forEach((card, index) => {
      if (
        currentfield !== "" &&
        currentindex !== null &&
        currentindex !== index
      ) {
        // This card didn't change - just add its totals
        totalBeforeMargin +=
          parseFloat(card.cost || 0) * parseFloat(card.qty || 0);
        totalAfterMargin +=
          parseFloat(card.customerCost || 0) * parseFloat(card.qty || 0);
        return; // Skip recalculation for this card
      }

      if (currentfield != "" && currentindex === index) {
        const customerCostLock = card.customerCostLock;
        const costLock = card.CostLock;
        const marginLock = card.marginLock;
        const qty = parseFloat(card.qty) || 0;
        let cost = parseFloat(card.cost) || 0;
        let margin = parseFloat(card.margin) || 0;
        let customerCost = parseFloat(card.customerCost) || 0;
        let totalSkuCost = 0;
        const lockFields = ["customerCostLock", "CostLock", "marginLock"];

        if (lockFields.includes(currentfield)) {
          return;
        }

        if (
          customerCostLock == false &&
          costLock == false &&
          marginLock == false
        ) {
          if (currentfield == "customerCost") {
            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            if (cost == 0) {
              margin = 0;
              setValue(
                `cards[${cards.indexOf(card)}].cost`,
                roundToMoney(totalSkuCost),
              );
            } else {
              margin = parseFloat(
                ((roundedCustomerCost - cost) / roundedCustomerCost) * 100,
              );
            }

            // ADDED: Store rounded customerCost
            // setValue(
            //   `cards[${cards.indexOf(card)}].customerCost`,
            //   roundedCustomerCost
            // );
            setValue(
              `cards[${cards.indexOf(card)}].margin`,
              roundToMoney(margin, 4),
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          } else {
            const customerCost = cost / (1 - margin / 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].customerCost`,
              roundedCustomerCost,
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          }
        } else if (customerCostLock == true) {
          if (currentfield == "cost") {
            margin = parseFloat(((customerCost - cost) / customerCost) * 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].margin`,
              roundToMoney(margin, 4),
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          } else if (currentfield == "margin") {
            const costCust = customerCost * (1 - margin / 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].cost`,
              roundToMoney(costCust),
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          } else {
            const customerCost = cost / (1 - margin / 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(`cards[${cards.indexOf(card)}].cost`, roundToMoney(cost));
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          }
        } else if (marginLock == true) {
          if (currentfield == "cost") {
            const customerCost = cost / (1 - margin / 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].customerCost`,
              roundedCustomerCost,
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          } else if (currentfield == "customerCost") {
            const costCust = customerCost * (1 - margin / 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].cost`,
              roundToMoney(costCust),
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          } else {
            const customerCost = cost / (1 - margin / 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(`cards[${cards.indexOf(card)}].cost`, roundToMoney(cost));
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          }
        } else if (costLock == true) {
          if (currentfield == "margin") {
            const customerCost = cost / (1 - margin / 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].customerCost`,
              roundedCustomerCost,
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          } else {
            margin = parseFloat(((customerCost - cost) / customerCost) * 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].margin`,
              roundToMoney(margin, 4),
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          }
        }

        // FIXED: Use rounded values for accumulation
        totalBeforeMargin += roundToMoney(cost * qty);
        totalAfterMargin += roundToMoney(totalSkuCost);
      } else {
        totalBeforeMargin += parseFloat(card.cost * card.qty);
        totalAfterMargin += parseFloat(card.customerCost * card.qty);
      }
    });

    // Calculate costs for each other cost
    otherCost?.forEach((costItem) => {
      const amount = parseFloat(costItem.Amount) || 0;
      if (amount > 0) {
        totalBeforeMargin += parseFloat(amount);
        totalAfterMargin += parseFloat(amount);
      }
    });

    if (shippingCost > 0) {
      totalBeforeMargin += parseFloat(shippingCost);
      totalAfterMargin += parseFloat(shippingCost);
    }

    // Add tax if enabled
    if (tax > 0) {
      totalBeforeMargin += parseFloat(tax);
      totalAfterMargin += parseFloat(tax);
    }

    // Set the final values - FIXED
    setTotalCostBeforeMargin(roundToMoney(totalBeforeMargin));
    setTotalCostAfterMargin(roundToMoney(totalAfterMargin));

    // Update form state - FIXED
    setValue("totalCostBeforeMargin", roundToMoney(totalBeforeMargin));
    setValue("totalCostAfterMargin", roundToMoney(totalAfterMargin));
  };

  const isCalculating = useRef(false);

  const shipping_terms = watch("shipping_terms");

  useEffect(() => {
    if (shipping_terms === "FOB Destination") {
      setShippingHide(true);
    }
  }, [watch("shipping_terms")]);

  useEffect(() => {
    const subscription = watch((value, { name }) => {
      //console.log('set name',name);
      const match = name?.match(
        /cards\[(\d+)\]\.(qty|cost|margin|customerCost)/,
      );
      const otherCostMatch = name?.match(/otherCost\[(\d+)\]\.Amount/);
      if (match || otherCostMatch) {
        if (!isCalculating.current) {
          isCalculating.current = true;
          calculateCosts(name);
          isCalculating.current = false;
        }
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    if (!isCalculating.current) {
      isCalculating.current = true;
      calculateCosts();
      isCalculating.current = false;
    }
  }, [watch("shippingCost"), watch("tax"), watch("cards"), watch("otherCost")]);

  const [activeCardIndex, setActiveCardIndex] = useState(null);
  const [cardSearch, setCardSearch] = useState(
    cardFields.map(() => ({
      vendor: "",
      description: "",
      sku: "",
      showSuggestions: true,
    })),
  );

  const handleInputFocus = (index) => {
    setActiveCardIndex(index);
    const updatedCardSearch = cardSearch.map((card, idx) => {
      if (idx !== index) {
        return { ...card, showSuggestions: false };
      }
      return card;
    });
    setCardSearch(updatedCardSearch);
  };

  const handleSearchChange = (index, field, value) => {
    const updatedCardSearch = [...cardSearch];
    if (field === "sku") {
      updatedCardSearch[index] = {
        ...updatedCardSearch[index],
        sku: value,
        vendor: "",
        description: "",
        showSuggestions: true,
      };
    } else if (field === "vendor") {
      updatedCardSearch[index] = {
        ...updatedCardSearch[index],
        vendor: value,
        sku: "",
        description: "",
        showSuggestions: true,
      };
    } else if (field === "description") {
      updatedCardSearch[index] = {
        ...updatedCardSearch[index],
        description: value,
        sku: "",
        vendor: "",
        showSuggestions: true,
      };
    }
    setCardSearch(updatedCardSearch);
  };

  const { postData: fetchProductSearch, data } = usePostRequest(
    API_ENDPOINTS.PRODUCT_SUGGETION,
  );

  const onSuccessData = (data) => {
    setDataSuggetion(data);
  };

  useEffect(() => {
    if (
      activeCardIndex === null ||
      !cardSearch[activeCardIndex]?.showSuggestions
    ) {
      return;
    }

    const { vendor, sku, description } = cardSearch[activeCardIndex];

    if (!vendor && !sku && !description) {
      return;
    }

    const debounceTimer = setTimeout(() => {
      fetchProductSearch(
        {
          page,
          limit,
          order_status: ordertype,
          module_type: "RFQ",
          // abbreviation: getValues("code") || undefined,
          is_variant: true,
          vendor: vendor?.length > 0 ? vendor : undefined,
          sku: sku?.length > 0 ? sku : undefined,
          description: description?.length > 0 ? description : undefined,
        },
        onSuccessData,
      );
    }, 500);
    return () => clearTimeout(debounceTimer);
  }, [cardSearch, page, limit, activeCardIndex]);

  const textAreaRefs = useRef([]);

  const adjustTextAreaHeight = (index) => {
    const textArea = textAreaRefs.current[index];
    if (textArea) {
      textArea.style.height = "auto";
      textArea.style.height = `${textArea.scrollHeight}px`;
    }
  };

  const handleProductSelect = (product, index) => {
    console.log("handleProductSelect", product);

    const currentValues = getValues("cards") || [];

    // const isDuplicate = currentValues.some(
    //   (item, idx) => item?.skuIdUnique === product?.sku_id && idx !== index
    // );

    // if (isDuplicate) {
    //   toast.error(
    //     `Product with SKU ${product.sku_display_name} already exists.`
    //   );
    //   return;
    // }

    setValue(`cards[${index}].vendorId`, product?.Vendor?.id, {
      shouldValidate: true,
    });

    setValue(`cards[${index}].vendorPartner`, product?.Vendor?.display_name, {
      shouldValidate: true,
    });
    setValue(`cards[${index}].skuIdUnique`, product?.sku_id, {
      shouldValidate: true,
    });
    setValue(`cards[${index}].productName`, product?.name, {
      shouldValidate: true,
    });
    setValue(`cards[${index}].skuId`, product?.sku_display_name, {
      shouldValidate: true,
    });

    setValue(`cards[${index}].skuDescription`, product?.description_sales, {
      shouldValidate: true,
    });

    setValue(`cards[${index}].purchase_description`, product?.description, {
      shouldValidate: true,
    });

    setValue(
      `cards[${index}].internalSku`,
      product?.internal_id || product?.vendor_sku || "",
      {
        shouldValidate: true,
      },
    );
    setValue(`cards[${index}].variantId`, product?.variant_id || "", {
      shouldValidate: true,
    });

    setValue(`cards[${index}].um`, product?.uoi, { shouldValidate: true });
    setValue(`cards[${index}].cost`, product?.aspetto_price, {
      shouldValidate: true,
    });
    setValue(`cards[${index}].customerCost`, product?.customer_price, {
      shouldValidate: true,
    });
    if (product?.customer_price === "0.00") {
      setValue(`cards[${index}].margin`, "8", {
        shouldValidate: true,
      });
    }
    // setValue(`cards[${index}].margin`, product?.margin_percent, {
    //   shouldValidate: true,
    // });

    // const textArea = textAreaRefs.current[index];
    // if (textArea) {
    //   textArea.value = product?.adjustTextAreaHeight;
    //   adjustTextAreaHeight(index);
    // }

    const textArea = textAreaRefs.current[index];
    if (textArea) {
      textArea.value = product?.description_sales; //description
      adjustTextAreaHeight(index);
    }

    const updatedCardSearch = [...cardSearch];
    updatedCardSearch[index] = {
      ...updatedCardSearch[index],
      showSuggestions: false,
    };
    setCardSearch(updatedCardSearch);
  };

  const handleQuickbookVendor = (quickbookVendor, product, index) => {
    // console.log("handleQuickbookVendor is triggered", quickbookVendor);

    // console.log("index", index);
    setValue(`cards[${index}].vendorPartner`, quickbookVendor, {
      shouldValidate: true,
    });
    setValue(`cards[${index}].skuIdUnique`, product?.sku_id, {
      shouldValidate: true,
    });
    setValue(`cards[${index}].skuId`, product?.sku_display_name, {
      shouldValidate: true,
    });

    setValue(`cards[${index}].skuDescription`, product?.description_sales, {
      shouldValidate: true,
    }); // Description update
    setValue(`cards[${index}].purchase_description`, product?.description, {
      shouldValidate: true,
    }); // Description update

    setValue(`cards[${index}].um`, product?.uoi, { shouldValidate: true });
    setValue(`cards[${index}].cost`, product?.aspetto_price, {
      shouldValidate: true,
    });
    setValue(`cards[${index}].customerCost`, product?.customer_price, {
      shouldValidate: true,
    });

    const textArea = textAreaRefs.current[index];
    if (textArea) {
      textArea.value = product?.description_sales;
      adjustTextAreaHeight(index);
    }
    setQuickbookVendor(null);
  };

  useEffect(() => {
    cardFields.forEach((_, index) => {
      adjustTextAreaHeight(index);
    });
  }, [cardFields]);

  useEffect(() => {
    if (quickbookVendor && selectedProduct && selectedIndex !== null) {
      console.log("funtion to add vendor through suggestion box triggered");
      handleQuickbookVendor(quickbookVendor, selectedProduct, selectedIndex);
      setSelectedProduct(null);
      setSelectedIndex(null);
    }
  }, [quickbookVendor]);

  const cards = watch("cards");

  const handleLockChange = (field, index) => {
    const currentState = watch(`cards[${index}]`);
    if (currentState[field]) {
      setValue(`cards[${index}].${field}`, false);
    } else {
      // Otherwise, lock it and unlock all others
      setValue(`cards[${index}].CostLock`, field === "CostLock");
      setValue(`cards[${index}].marginLock`, field === "marginLock");
      setValue(
        `cards[${index}].customerCostLock`,
        field === "customerCostLock",
      );
    }
  };

  const updateTextAreaWithDescription = (index, description) => {
    const textArea = textAreaRefs.current[index];
    if (textArea) {
      textArea.value = description;
      adjustTextAreaHeight(index);
    }
  };

  const handleBlur = (index) => {
    // setDataSuggetion(null);
    // setTimeout(() => {
    //   const updatedCardSearch = [...cardSearch];
    //   updatedCardSearch[index] = {
    //     ...updatedCardSearch[index],
    //     showSuggestions: false,
    //   };
    //   setCardSearch(updatedCardSearch);
    // }, 150);
  };

  const suggestionBoxRefs = useRef([]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the click is outside all suggestion boxes
      const isClickOutside = cardSearch.every((_, index) => {
        const suggestionBox = suggestionBoxRefs.current[index];
        return suggestionBox && !suggestionBox.contains(event.target);
      });

      if (isClickOutside) {
        // Close all suggestion boxes and clear suggestions
        setDataSuggetion(null);
        setCardSearch((prev) =>
          prev.map((card) => ({
            ...card,
            showSuggestions: false,
          })),
        );
      }
    };

    // Add event listener for mousedown
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [cardSearch]);

  const selectedContractVehicleType = watch("contract_vehicle_type");

  return (
    <>
      <SkuSearchPopUp
        calculateCosts={calculateCosts}
        ordertype={ordertype}
        show={showModal}
        searchProps={searchProps}
        updateTextArea={updateTextAreaWithDescription}
        setSearchProps={setSearchProps}
        setShow={setShowModal}
        onAddSku={handleAddSku}
        setCardSearch={setCardSearch}
        cardSearch={cardSearch}
      />
      <div className="drag_section">
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="droppable-cards">
            {(provided) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                {cardFields.map((card, index) => (
                  <Draggable
                    key={card.id}
                    draggableId={`card-${index}`}
                    index={index}
                  >
                    {(provided) => (
                      <Card
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className="mb-3"
                      >
                        <Card.Body>
                          <div className="grag_flex_row">
                            <div className="drag_icon_set">
                              <div
                                className="drag_icon_group trash_icon"
                                {...provided.dragHandleProps}
                              >
                                {cardFields.length > 1 && (
                                  <IconTrash
                                    onClick={() => handleRemoveCard(index)}
                                  />
                                )}
                                <IconArrowsUpDown style={{ cursor: "move" }} />
                              </div>
                            </div>

                            <input
                              type="hidden"
                              {...register(`cards[${index}].variantId`)}
                            />

                            <div className="drag_fields_grid">
                              <div className="drag_fields_left">
                                <div>
                                  <Form.Group>
                                    <Form.Label className="">
                                      VENDOR NAME
                                    </Form.Label>
                                    <InputGroup>
                                      <Form.Control
                                        {...register(
                                          `cards[${index}].vendorPartner`,
                                        )}
                                        onBlur={() => handleBlur(index)}
                                        defaultValue={card.vendorPartner}
                                        placeholder="Enter Name"
                                        // value={cardSearch[activeCardIndex]?.vendor || ""}
                                        onChange={(e) =>
                                          handleSearchChange(
                                            activeCardIndex,
                                            "vendor",
                                            e.target.value,
                                          )
                                        }
                                        onFocus={() => handleInputFocus(index)}
                                      />
                                    </InputGroup>
                                    {errors?.cards?.[index]?.vendorPartner && (
                                      <span className="text-danger">
                                        {/* {errors.cards[index].vendorPartner.message} */}
                                      </span>
                                    )}
                                  </Form.Group>
                                </div>

                                <div>
                                  <Form.Group>
                                    <Form.Label className="">
                                      PRODUCT NAME
                                    </Form.Label>
                                    <InputGroup>
                                      <Form.Control
                                        {...register(
                                          `cards[${index}].productName`,
                                        )}
                                        // value={watch(`cards[${index}].skuId`)}
                                        placeholder="Product Name"
                                        // defaultValue={card.skuId}
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </div>

                                {showSkuId && (
                                  <>
                                    <div className="mid_drag_column mob_50">
                                      <Form.Group>
                                        <Form.Label className="required">
                                          UNIQUE SKU ID
                                        </Form.Label>
                                        <InputGroup>
                                          <Form.Control
                                            {...register(
                                              `cards[${index}].skuIdUnique`,
                                            )}
                                            // value={watch(`cards[${index}].skuId`)}
                                            placeholder="SKU ID"
                                            // defaultValue={card.skuId}
                                          />
                                        </InputGroup>
                                      </Form.Group>
                                    </div>
                                    <div className="mid_drag_column mob_50">
                                      <Form.Group>
                                        <Form.Label className="required">
                                          ROW ID
                                        </Form.Label>
                                        <InputGroup>
                                          <Form.Control
                                            {...register(
                                              `cards[${index}].rowId`,
                                            )}
                                            placeholder="ROW ID"
                                          />
                                        </InputGroup>
                                      </Form.Group>
                                    </div>
                                  </>
                                )}

                                <div>
                                  <Form.Group>
                                    <Form.Label>INTERNAL SKU</Form.Label>
                                    <InputGroup>
                                      <Form.Control
                                        {...register(
                                          `cards[${index}].internalSku`,
                                        )}
                                        placeholder="Internal SKU"
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </div>

                                <div>
                                  <Form.Group>
                                    <Form.Label className="">
                                      VENDOR SKU
                                    </Form.Label>
                                    <InputGroup>
                                      <Form.Control
                                        {...register(`cards[${index}].skuId`)}
                                        onBlur={() => handleBlur(index)}
                                        // value={watch(`cards[${index}].skuId`)}
                                        placeholder="VENDOR SKU"
                                        defaultValue={card.skuId}
                                        onChange={(e) =>
                                          handleSearchChange(
                                            activeCardIndex,
                                            "sku",
                                            e.target.value,
                                          )
                                        }
                                        onFocus={() => handleInputFocus(index)}
                                      />
                                    </InputGroup>
                                    {errors?.cards?.[index]?.skuId && (
                                      <span className="text-danger">
                                        {/* {errors.cards[index].skuId.message} */}
                                      </span>
                                    )}
                                  </Form.Group>
                                </div>
                              </div>

                              <div className="drag_fields_center">
                                <Form.Group
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    flex: 1,
                                  }}
                                >
                                  <Form.Label className="">
                                    SKU DESCRIPTION
                                  </Form.Label>
                                  <InputGroup>
                                    <Form.Control
                                      as="textarea"
                                      rows={1} // Adjust the number of visible text lines
                                      {...register(
                                        `cards[${index}].skuDescription`,
                                      )}
                                      defaultValue={card.skuDescription}
                                      placeholder="Description"
                                      ref={(el) => {
                                        textAreaRefs.current[index] = el;
                                      }}
                                      style={{
                                        resize: "none",
                                        overflow: "hidden",
                                      }}
                                      onBlur={() => handleBlur(index)}
                                      onChange={(e) => {
                                        handleSearchChange(
                                          index,
                                          "description",
                                          e.target.value,
                                          setValue(
                                            `cards[${index}].skuDescription`,
                                            e.target.value,
                                          ),
                                        );
                                        adjustTextAreaHeight(index); // Resize on input change
                                      }}
                                      onFocus={() => handleInputFocus(index)}
                                    />
                                  </InputGroup>
                                  {errors?.cards?.[index]?.skuDescription && (
                                    <span className="text-danger">
                                      {/* {errors.cards[index].skuDescription.message} */}
                                    </span>
                                  )}
                                </Form.Group>
                              </div>
                              <div className="drag_fields_right">
                                {selectedContractVehicleType?.includes(
                                  "product-bound",
                                ) && (
                                  <div>
                                    <Form.Group>
                                      <Form.Label className="">
                                        MAX QTY
                                      </Form.Label>
                                      <InputGroup>
                                        <Form.Control
                                          type="text"
                                          onKeyDown={handleKeyDown}
                                          step="any"
                                          {...register(
                                            `cards[${index}].qty`,
                                            //    {
                                            //   required: "Quantity is required",
                                            //   pattern: {
                                            //     value: /^[0-9]+$/,
                                            //     message: "Quantity must be a number",
                                            //   },
                                            // }
                                          )}
                                          defaultValue={card.qty}
                                          placeholder="0"
                                        />
                                      </InputGroup>
                                      {errors?.cards?.[index]?.qty && (
                                        <span className="text-danger">
                                          {/* {errors.cards[index].qty.message} */}
                                        </span>
                                      )}
                                    </Form.Group>
                                  </div>
                                )}

                                <div>
                                  <Form.Group className="lock_group">
                                    <Form.Label className="">Cost</Form.Label>
                                    <InputGroup>
                                      <InputGroup.Text>
                                        <IconCurrencyDollar stroke={2} />
                                      </InputGroup.Text>

                                      <Form.Control
                                        type="text"
                                        step="any"
                                        onKeyDown={handleKeyDown}
                                        {...register(
                                          `cards[${index}].cost`,
                                          //   {
                                          //   required: "Cost is required",
                                          //   pattern: {
                                          //     value: /^[0-9]+(\.[0-9]{1,2})?$/,
                                          //     message: "Enter a valid cost",
                                          //   },
                                          // }
                                        )}
                                        defaultValue={card.cost}
                                        placeholder="Enter Cost"
                                        disabled={watch(
                                          `cards[${index}].CostLock`,
                                        )}
                                      />
                                    </InputGroup>
                                    {errors?.cards?.[index]?.cost && (
                                      <span className="text-danger">
                                        {/* {errors.cards[index].cost.message} */}
                                      </span>
                                    )}
                                    <span className="lock_unlock">
                                      <Form.Check
                                        type="switch" // Using 'switch' for better visual feedback, but you can keep 'checkbox' if preferred
                                        id={`lock-toggle-${index}`}
                                        label={
                                          <>
                                            {watch(
                                              `cards[${index}].CostLock`,
                                            ) ? (
                                              <IconLock stroke={1} />
                                            ) : (
                                              <IconLockOpen2 stroke={1} />
                                            )}
                                          </>
                                        }
                                        {...register(
                                          `cards[${index}].CostLock`,
                                        )}
                                        checked={watch(
                                          `cards[${index}].CostLock`,
                                        )}
                                        onChange={() =>
                                          handleLockChange("CostLock", index)
                                        }
                                        step="any"
                                      />
                                    </span>
                                  </Form.Group>
                                </div>

                                <div>
                                  <Form.Group className="lock_group">
                                    <Form.Label className="">Margin</Form.Label>
                                    <InputGroup>
                                      <InputGroup.Text>
                                        <IconPercentage stroke={2} />
                                      </InputGroup.Text>

                                      <Form.Control
                                        onKeyDown={handleKeyDown}
                                        type="text"
                                        {...register(`cards[${index}].margin`)}
                                        defaultValue={card.margin}
                                        placeholder="0.00"
                                        disabled={watch(
                                          `cards[${index}].marginLock`,
                                        )}
                                        step="any"
                                      />
                                    </InputGroup>
                                    {errors?.cards?.[index]?.margin && (
                                      <span className="text-danger">
                                        {/* {errors.cards[index].margin.message} */}
                                      </span>
                                    )}
                                    <span className="lock_unlock">
                                      <Form.Check
                                        type="switch" // Using 'switch' for better visual feedback, but you can keep 'checkbox' if preferred
                                        id={`margin-lock-toggle-${index}`}
                                        label={
                                          <>
                                            {watch(
                                              `cards[${index}].marginLock`,
                                            ) ? (
                                              <IconLock stroke={1} />
                                            ) : (
                                              <IconLockOpen2 stroke={1} />
                                            )}
                                          </>
                                        }
                                        {...register(
                                          `cards[${index}].marginLock`,
                                        )}
                                        checked={watch(
                                          `cards[${index}].marginLock`,
                                        )}
                                        onChange={() =>
                                          handleLockChange("marginLock", index)
                                        }
                                      />
                                    </span>
                                  </Form.Group>
                                </div>

                                <div>
                                  <Form.Group className="lock_group">
                                    <Form.Label>Price</Form.Label>
                                    <InputGroup>
                                      <InputGroup.Text>
                                        <IconCurrencyDollar stroke={2} />
                                      </InputGroup.Text>
                                      <Form.Control
                                        type="text"
                                        onKeyDown={handleKeyDown}
                                        {...register(
                                          `cards[${index}].customerCost`,
                                        )}
                                        step="any"
                                        defaultValue={card.customerCost}
                                        placeholder="Price"
                                        disabled={watch(
                                          `cards[${index}].customerCostLock`,
                                        )}
                                        checked={watch(
                                          `cards[${index}].customerCostLock`,
                                        )}
                                      />
                                    </InputGroup>
                                    {errors?.cards?.[index]?.customerCost && (
                                      <span className="text-danger">
                                        {/* {errors.cards[index].customerCost.message} */}
                                      </span>
                                    )}
                                    <span className="lock_unlock">
                                      <Form.Check
                                        type="switch"
                                        id={`customer-cost-lock-toggle-${index}`}
                                        label={
                                          <>
                                            {watch(
                                              `cards[${index}].customerCostLock`,
                                            ) ? (
                                              <IconLock stroke={1} />
                                            ) : (
                                              <IconLockOpen2 stroke={1} />
                                            )}
                                          </>
                                        }
                                        {...register(
                                          `cards[${index}].customerCostLock`,
                                        )}
                                        checked={watch(
                                          `cards[${index}].customerCostLock`,
                                        )}
                                        onChange={() =>
                                          handleLockChange(
                                            "customerCostLock",
                                            index,
                                          )
                                        }
                                      />
                                    </span>
                                  </Form.Group>
                                </div>

                                <div className="drag_fields_right_row2">
                                  <div>
                                    <Form.Group>
                                      <Form.Label className="">CLIN</Form.Label>
                                      <InputGroup>
                                        <Form.Control
                                          // onKeyDown={handleKeyDown}
                                          step="any"
                                          {...register(
                                            `cards[${index}].clin`,
                                            //    {
                                            //   required: "Quantity is required",
                                            //   pattern: {
                                            //     value: /^[0-9]+$/,
                                            //     message: "Quantity must be a number",
                                            //   },
                                            // }
                                          )}
                                          placeholder="CLIN"
                                        />
                                      </InputGroup>
                                      {errors?.cards?.[index]?.clin && (
                                        <span className="text-danger">
                                          {/* {errors.cards[index].clin.message} */}
                                        </span>
                                      )}
                                    </Form.Group>
                                  </div>

                                  <div>
                                    <Form.Group>
                                      <Form.Label>UM</Form.Label>
                                      <InputGroup>
                                        <Form.Control
                                          {...register(`cards[${index}].um`)}
                                          defaultValue={card.um}
                                          placeholder="EA"
                                        />
                                      </InputGroup>
                                      {errors?.cards?.[index]?.um && (
                                        <span className="text-danger">
                                          {/* {errors.cards[index].qty.message} */}
                                        </span>
                                      )}
                                    </Form.Group>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* <Col className="mob_50">
                              <Form.Group>
                                <Form.Label>Total SKU Price</Form.Label>
                                <InputGroup>
                                  <InputGroup.Text>
                                    <IconCurrencyDollar stroke={2} />
                                  </InputGroup.Text>
                                  <Form.Control
                                    readOnly
                                    type="number"
                                    onKeyDown={handleKeyDown}
                                    {...register(
                                      `cards[${index}].totalSkuCost`,
                                      {
                                        required: "Total SKU cost is required",
                                        pattern: {
                                          value: /^[0-9]+(\.[0-9]{1,2})?$/,
                                          message:
                                            "Enter a valid total SKU cost",
                                        },
                                      }
                                    )}
                                    defaultValue={card.totalSkuCost}
                                    placeholder="Total SKU Cost"
                                  />
                                </InputGroup>
                                {errors?.cards?.[index]?.totalSkuCost && (
                                  <span className="text-danger">
                                    {errors.cards[index].totalSkuCost.message}
                                  </span>
                                )}
                              </Form.Group>
                            </Col> */}
                          </div>
                          {cardSearch[index]?.showSuggestions &&
                            (cardSearch[index]?.vendor ||
                              cardSearch[index]?.sku ||
                              cardSearch[index]?.description) &&
                            dataSuggetion?.data?.length > 0 && (
                              <div
                                className="suggestions_box"
                                ref={(el) =>
                                  (suggestionBoxRefs.current[index] = el)
                                }
                              >
                                <div className="table-responsive">
                                  <Table>
                                    <tbody>
                                      {dataSuggetion.data.map(
                                        (product, idx) => (
                                          <tr
                                            key={idx}
                                            onClick={() =>
                                              handleProductSelect(
                                                product,
                                                index,
                                              )
                                            }
                                          >
                                            <td>
                                              {product?.Vendor?.display_name}
                                            </td>
                                            <td>{product?.sku_display_name}</td>
                                            <td>{product?.name}</td>
                                            <td>
                                              {" "}
                                              {trimText(
                                                product?.description,
                                                100,
                                              )}
                                            </td>
                                            <td>{product?.uoi}</td>
                                            <td>${product?.aspetto_price}</td>
                                            <td>{product?.margin_percent}%</td>
                                          </tr>
                                        ),
                                      )}
                                    </tbody>
                                  </Table>
                                </div>
                                <div className="text-center">
                                  <Button
                                    variant="link"
                                    className="see-all-btn"
                                    onClick={() =>
                                      handleOpenModal(index, "sku")
                                    }
                                  >
                                    See All SKUs <IconArrowNarrowRight />
                                  </Button>
                                </div>
                              </div>
                            )}
                        </Card.Body>
                      </Card>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>

          <div className="add_remove_sku mb-3">
            <p className="text-center mb-2">Product Items (SKUs)</p>
            <div className="btn_group_sku">
              <Button
                variant=""
                className="add_sku_button"
                onClick={handleAddCard}
              >
                <IconPlus /> BLANK PRODUCT
              </Button>
              <Button
                variant=""
                className="add_sku_button"
                onClick={() => handleOpenModal(null, "skuAll")}
              >
                <IconSearch /> PRODUCTS LIBRARY
              </Button>

              {/* <Button
                variant=""
                className="add_sku_button"
                onClick={() => handleOpenModal(null, "contract")}
              >
                <IconSearch /> BROWSE BY CONTRACT VEHICLE
              </Button> */}
            </div>
          </div>
        </DragDropContext>
      </div>
      {/* <div>
        <Card.Body>
          <Row className={`mb-2 ${shippingHide ? "d-none" : ""}`}>
            <div className="costing_rows p-0">
              <Form.Check
                className="ps-0 pe-2"
                type="switch"
                label="Shipping Cost"
                {...register("shippingCostEnabled")}
                checked={getValues("shippingCostEnabled")}
                onChange={(e) =>
                  setValue("shippingCostEnabled", e.target.checked)
                }
              />
              <div className="costing_input">
                <Form.Group>
                  <InputGroup>
                    <InputGroup.Text>
                      <IconCurrencyDollar stroke={2} />
                    </InputGroup.Text>
                    <Form.Control
                      type="number"
                      onKeyDown={handleKeyDown}
                      {...register("shippingCost", {
                        required: watch("shippingCostEnabled")
                          ? "Shipping cost is required"
                          : false,
                      })}
                      disabled={!watch("shippingCostEnabled")}
                    />
                  </InputGroup>
                </Form.Group>
              </div>
            </div>
          </Row>

          <Row className="mb-2">
            <div className="costing_rows p-0">
              <Form.Check
                className="ps-0 pe-2"
                type="switch"
                label="Tax"
                {...register("taxEnabled")}
                checked={getValues("taxEnabled")}
                onChange={(e) => setValue("taxEnabled", e.target.checked)}
              />

              <div className="costing_input">
                <Form.Group>
                  <InputGroup>
                    <InputGroup.Text>
                      <IconCurrencyDollar />
                    </InputGroup.Text>
                    <Form.Control
                      type="number"
                      // defaultValue={0.00}
                      onKeyDown={handleKeyDown}
                      {...register("tax", {
                        required: watch("taxEnabled")
                          ? "Tax is required"
                          : false,
                      })}
                      disabled={!watch("taxEnabled")}
                    />
                  </InputGroup>
                </Form.Group>
              </div>
            </div>
          </Row>
          <Row className="mb-2 justify-content-end">
            {otherCostFields.map((item, index) => (
              <Row className="mb-2" key={item.id}>
                <div className="costing_rows p-0">
                  <div className="costing_input">
                    <span
                      className="trash_icon"
                      onClick={() => handleRemoveOthercost(index)}
                    >
                      <IconTrash />
                    </span>
                    <Form.Group>
                      <InputGroup className="costing_name">
                        <Form.Control
                          {...register(`otherCost[${index}].Name`)}
                          placeholder="Enter Cost Name"
                        />
                      </InputGroup>
                    </Form.Group>

                    <Form.Group>
                      <InputGroup className="costing_amount">
                        <InputGroup.Text>
                          <IconCurrencyDollar />
                        </InputGroup.Text>
                        <Form.Control
                          type="number"
                          {...register(`otherCost[${index}].Amount`, {
                            required: "Amount is required",
                            pattern: {
                              value: /^[0-9]+(\.[0-9]{1,2})?$/,
                              message: "Enter a valid amount",
                            },
                          })}
                          placeholder="Amount"
                        />
                      </InputGroup>
                    </Form.Group>
                  </div>
                </div>
              </Row>
            ))}
            <div className="costing_rows p-0">
              <Button
                variant=""
                className="add_sku_button w-auto"
                onClick={handleAddOtherCost}
              >
                <IconPlus /> OTHER COST
              </Button>
            </div>
          </Row>

          <div className="totle_costing mt-3">
            <h6>
              Total Cost Before Margin:
              <span>
                <IconCurrencyDollar />
                {totalCostBeforeMargin}
              </span>
            </h6>
            <Form.Control
              {...register("totalCostBeforeMargin")}
              value={totalCostBeforeMargin}
              readOnly
              type="hidden"
              placeholder="Total Cost Before Margin"
            />
          </div>
          <div className="totle_costing">
            <h6>
              Total Cost After Margin:
              <span>
                <IconCurrencyDollar />
                {totalCostAfterMargin}
              </span>
            </h6>
            <Form.Control
              {...register("totalCostAfterMargin")}
              value={totalCostAfterMargin}
              readOnly
              type="hidden"
              placeholder="Total Cost After Margin"
            />
          </div>
        </Card.Body>
      </div> */}
    </>
  );
}

export default OtherDetailsForm;
